import { addDays, format, isValid, parse, subDays } from 'date-fns';
import type { Day } from '@/contexts/ItineraryContext';

/** Matches timeline day `date` strings from createEmptyDays / addDay. */
export const TIMELINE_DAY_DATE_FORMAT = 'eee, MMM d, yyyy';

/** Parse display strings from `format(..., 'eee, MMM d, yyyy')` (weekday cannot share a parse pattern with MMM in date-fns v4). */
export function parseTimelineDayDate(value: string | undefined): Date | null {
  if (!value?.trim()) return null;
  const trimmed = value.trim();
  const withoutWeekday = trimmed.replace(/^[^,]+,\s*/, '');
  const parsed = parse(withoutWeekday, 'MMM d, yyyy', new Date());
  return isValid(parsed) ? parsed : null;
}

/**
 * Reassigns each day's `date` to a contiguous sequence starting from an inferred trip start
 * (first parseable date minus its index). Fixes duplicate or shifted dates after insert/reorder.
 */
export function resequenceTimelineDayDates(days: Day[]): void {
  if (days.length === 0) return;

  let firstIdx = -1;
  let firstDate: Date | null = null;
  for (let i = 0; i < days.length; i++) {
    const d = parseTimelineDayDate(days[i].date);
    if (d) {
      firstIdx = i;
      firstDate = d;
      break;
    }
  }

  const tripStart =
    firstIdx >= 0 && firstDate ? subDays(firstDate, firstIdx) : new Date();

  for (let i = 0; i < days.length; i++) {
    days[i].date = format(addDays(tripStart, i), TIMELINE_DAY_DATE_FORMAT);
  }
}
